<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
  padding-bottom: 40px;
}
</style>
<template>
  <div class="coustomer-wrap">
    <el-dialog title="备用金(个人借款)"
      :visible.sync="dialogVisible"
      top="3vh"
      :close-on-click-modal="false" :close-on-press-escape="false"
      :destroy-on-close="true"
      width="460px">
      <el-form ref="formDataRef" :model="formData" label-width="90px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="title" label="申请事由">
          <el-input v-model="formData.title" placeholder="请填写申请事由"></el-input>
        </el-form-item>

        <el-form-item prop="receive_name" label="收款人">
          <el-input v-model="formData.receive_name" placeholder="请填写收款人"></el-input>
        </el-form-item>
        <el-form-item prop="receive_bank_type" label="开户行">
          <el-input v-model="formData.receive_bank_type" placeholder="请填写开户行"></el-input>
        </el-form-item>
        <el-form-item prop="receive_bank_no" label="收款账号	">
          <el-input v-model="formData.receive_bank_no" placeholder="请填写收款账号"></el-input>
        </el-form-item>
        <el-form-item prop="back_time	" label="最晚归还日期">
          <el-date-picker
            style="width: 100%;"
            v-model="formData.back_time"
            format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="coin_type	" label="选择币种">
          <el-select v-model="formData.coin_type" placeholder="请选择币种"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="coinItem in coins"
              :label="coinItem.name"
              v-show="coinItem.showApplayReserveFunds"
              :key="coinItem.id"
              :value="coinItem.id">
              {{coinItem.name}}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sum_money	" label="备用金金额">
          <el-input-number style="width: 100%;" v-model="formData.sum_money"
            :precision="2" :step="1" :min="0" :max="1000000"
            @blur="moneyChangeHandler(formData.sum_money, formData)">
          </el-input-number>
        </el-form-item>
        <el-form-item prop="remark	" label="备注信息">
          <el-input v-model="formData.remark" type="textarea" placeholder="请填写备注信息">
          </el-input>
        </el-form-item>
        <el-form-item label="上传附件" class="extension">
          <template slot="label">
            上传附件
            <az-issue :tipW="200"
              text="仅支持jpg , jpeg, png, pdf"></az-issue>
          </template>
          <div class="invoice-wrap1">
            <el-upload
              ref="upload"
              drag
              class="avatar-uploader"
              :file-list="formData.img_keys"
              accept=".jpg,.jpeg,.png,.pdf"
              :action="`/api/base/upload?az_tk=${token}`"
              :on-remove="handleRemove"
              :on-exceed="handleExceed"
              :limit="5"
              :on-success="(res,file,fileList) =>handleAvatarSuccess(res,file,fileList)"
              :before-upload="(file)=>beforeAvatarUpload(file)">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

      </el-form>
      <div class="dialog-footer">
        <el-button slot="reference" size="small" type="primary"
          :loading="btnIsLoading"
          @click="submitHandler">确认提交
        </el-button>
        <el-button slot="reference" size="small" @click="dialogVisible = false"
          style="margin-left: 10px;">取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { coins } from '@/const'
import azIssue from '@/base/azIssue.vue'
import { createApprovalInstance, modifyOriginalFrom } from '@/api/approval'

const formDataDefault = {
  title: '', // 事由
  sum_money: 0, // 总金额
  receive_name: '', // 收款人
  receive_bank_type: '', // 收款人开户行
  receive_bank_no: '', // 收款账号
  back_time: '',// 最晚还款日期
  coin_type: '', // 币种: 1人民币, 2美元,3新币,4日元,5韩元
  remark: '',
  img_keys: []
}
export default {
  name: 'applayReserveFunds', // 用款申请
  props: {
    title: {
      type: String,
      default: ''
    },
  },
  components: {
    azIssue
  },
  computed: {
    token() {
      return this.$store.getters.token;
    },
  },
  data() {
    return {
      operationType: 'create',
      task_id: '',
      coins,
      formData: JSON.parse(JSON.stringify(formDataDefault)),
      dialogVisible: false,
      btnIsLoading: false,
      type: 'create',
      companys: [],
      otherCompanys: [],
      otherCompanyBanks: [],
      img_keys: []
    }
  },
  mounted() {
    this.$on('open', (formData) => {
      this.operationType = 'create';
      this.type = formData ? 'edit' : 'create'
      this.formData = JSON.parse(JSON.stringify(formDataDefault))
      this.dialogVisible = true
    })
    this.$on('edit', (task_id, data) => {
      this.operationType = 'edit';
      this.task_id = task_id;
      this.dialogVisible = true;
      const {
        title,
        sum_money,
        receive_name,
        receive_bank_type,
        receive_bank_no,
        back_time,
        coin_type,
        img_keys,
        remark
      } = data;

      this.formData = {
        title,
        sum_money,
        receive_name,
        receive_bank_type,
        receive_bank_no,
        back_time,
        coin_type,
        img_keys: img_keys || [],
        remark
      }
    })
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.formData.img_keys = fileList;
      console.log(this.img_keys, 'delete')
    },
    handleExceed(files, fileList) {
      this.$message({
        message: '同时最多只能上传5个文件',
        type: 'error'
      });
    },
    handleAvatarSuccess(res, file, fileList) {
      if (res.code != 0 || !res.data) {
        this.$message.error('上传失败');
      } else {
        // this.formData.img_keys = fileList;
        this.formData.img_keys.push({ name: file.name, key: res.data.key });
        this.$message({
          message: '上传成功',
          type: 'success'
        });
      }
    },
    beforeAvatarUpload(file) {
      console.log(file)
      console.log(this.fileList, 'fileList')
      let isImg = true;
      if (file.name) {
        const names = file.name.split('.');
        isImg = ['png', 'jpg', 'jpeg', 'pdf'].includes(names[names.length - 1]);
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isImg) {
        this.$message.error('请上传png, jpg, jpeg, pdf类型的文件');
        return false;
      }
      // 判断上传文件格式是否正确
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 20MB!');
        return false;
      }
      return true
    },
    moneyChangeHandler(moeny, item) {
      if (typeof moeny !== 'number') {
        item.money = 0
      }
    },
    submitHandler() {
      console.log(1112)
      this.formData.img_keys = this.formData.img_keys.map(item => {
        return { name: item.name, key: item.key }
      })
      this[`${this.operationType}ApprovalInstanceHandler`]()
      // createApprovalInstance(2, this.formData).then(res => {
      //   if (res.code != 0) throw new Error(res.message)
      //   this.$message.success('保存成功')
      //   this.dialogVisible = false
      //   this.$emit('refresh')
      // }).catch(err => {
      //   this.$message.error(err.message)
      // }).finally(() => {
      //   this.btnIsLoading = false
      // })
    },
    createApprovalInstanceHandler() {
      this.btnIsLoading = true
      createApprovalInstance(2, this.formData).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    },
    editApprovalInstanceHandler() {
      this.btnIsLoading = true;
      console.log(this.formData, 'edit')
      modifyOriginalFrom(this.task_id, this.formData).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.btnIsLoading = false
      })
    }
  },

}
</script>